import M from "moment";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleInput from "../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import React from "react";

export const formGroupReceivingKSU = {
    spbmNo: {value: ""},
    spbmDate: {value: null},
    spbkNo: {value: ""},
    spbkDate: {value: M(new Date()).format("DD-MM-YYYY"), mandatory: true},
    slNo: {value: ""},
    slDate: {value: null},
    noPolKendaraan: {value: ""},
    idSupplier: {value: {}, mandatory: true},
    idSupplierExpedisi: {value: {}},
    note: {value: ""},
    kodeCabang: {value: ""},
    listRequestDetailKsu: {value: []},
};

export const filterConfig = {
    hadiah: {
        dateLabel: "Tanggal SPBH",
        dateName: "tanggalspbh",
        noLabel: "No. SPBK",
        noName: "nospbk",
        codeLabel: "Kode Hadiah",
        codeName: "kodehadiah",
        categoryLabel: "Kategori Hadiah",
        categoryName: "kategorihadiah",
    },
    baranglain: {
        dateLabel: "Tanggal SPBL",
        dateName: "tanggalspbl",
        noLabel: "No. SPBL",
        noName: "nospbl",
        codeLabel: "Kode Barang Lain",
        codeName: "kodebaranglain",
        categoryLabel: "Kategori Barang Lain",
        categoryName: "kategoribaranglain",
    },
    ksu: {
        dateLabel: "Tanggal SPBK",
        dateName: "tanggalspbk",
        noLabel: "No. SPBK",
        noName: "noSPBK",
        codeLabel: "Kode KSU",
        codeName: "kodeKSU",
        categoryLabel: "Kategori KSU",
        categoryName: "kategoriKSU",
    },
};

export const inputConfig = {
    hadiah: {
        noLabel: "No. SPBH",
        noName: "nospbh",
        dateLabel: "Tgl. SPBH",
        dateName: "tglspbh",
    },
    baranglain: {
        noLabel: "No. SPBL",
        noName: "nospbl",
        dateLabel: "Tgl. SPBL",
        dateName: "tglspbl",
    },
    ksu: {
        noLabel: "No. SPBK",
        noName: "noSpbk",
        dateLabel: "Tgl. SPBK",
        dateName: "tglSpbk",
    },
};

export const tabTableConfig = {
    hadiah: {
        ...inputConfig.hadiah,
        table: {
            type: "tab",
            firstPanelConfig: [
                {
                    name: "kodehadiah",
                    label: "Kode Hadiah",
                },
                {
                    name: "namahadiah",
                    label: "Nama Hadiah",
                },
                {
                    name: "kategori",
                    label: "Kategori",
                },
                {
                    name: "qrcode",
                    label: "QRCode",
                },
                {
                    name: "locator",
                    label: "Locator",
                },
                {
                    name: "jmlprint",
                    label: "Jml. Print",
                },
            ],
            secondPanelConfig: [
                {
                    name: "id",
                    label: "No",
                },
                {
                    name: "kodehadiah",
                    label: "Kode Hadiah",
                },
                {
                    name: "namahadiah",
                    label: "Nama Hadiah",
                },
                {
                    name: "kategori",
                    label: "Kategori",
                },
                {
                    name: "jumlah",
                    label: "Jumlah",
                },
                {
                    name: "satuan",
                    label: "Satuan",
                },
                {
                    name: "locator",
                    label: "Locator",
                },
            ],
            firstPanelData: [
                {
                    id: 1,
                    kodebarang: "barang lain H1234",
                    namabaranglain: "barang lain Jaket AHM",
                    kategori: "barang lain HGA",
                    qrcode: "barang lain HDH/XXXXX",
                    locator: "barang lain WDD1D1D1",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodebarang: "barang lainXXXX",
                    namabaranglain: "barang lainXXXX",
                    kategori: "barang lainXXX",
                    qrcode: "barang lainXXXX",
                    locator: "barang lainXXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodebarang: "XXXX",
                    namabaranglain: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodebarang: "XXXX",
                    namabaranglain: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodebarang: "XXXX",
                    namabaranglain: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodebarang: "XXXX",
                    namabaranglain: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
            ],
            secondPanelData: [
                {
                    id: 1,
                    kodebarang: "barang lainH1234",
                    namabaranglain: "barang lainJaket NIM",
                    kategori: "barang lainJaket Gift",
                    jumlah: 125,
                    satuan: "barang lainPcs",
                    locator: "barang lainWH010101",
                },
                {
                    id: 2,
                    kodebarang: "barang lainH321",
                    namabaranglain: "barang lainSarung Tangan",
                    kategori: "barang lainGlove",
                    jumlah: 350,
                    satuan: "barang lainSet",
                    locator: "barang lainWHD1D1D1",
                },
            ],
        },
    },
    baranglain: {
        ...inputConfig.baranglain,
        table: {
            type: "tab",
            firstPanelConfig: [
                {
                    name: "kodebarang",
                    label: "Kode Barang",
                },
                {
                    name: "namabaranglain",
                    label: "Nama Barang Lain",
                },
                {
                    name: "kategori",
                    label: "Kategori",
                },
                {
                    name: "qrcode",
                    label: "QRCode",
                },
                {
                    name: "locator",
                    label: "Locator",
                },
                {
                    name: "jmlprint",
                    label: "Jml. Print",
                },
            ],
            secondPanelConfig: [
                {
                    name: "kodabarang",
                    label: "Kode Barang",
                },
                {
                    name: "namabaranglain",
                    label: "Nama Barang Lain",
                },
                {
                    name: "kategori",
                    label: "Kategori",
                },
                {
                    name: "jumlah",
                    label: "Jumlah",
                },
                {
                    name: "satuan",
                    label: "Satuan",
                },
                {
                    name: "locator",
                    label: "Locator",
                },
            ],
            firstPanelData: [
                {
                    id: 1,
                    kodehadiah: "H1234",
                    namahadiah: "Jaket AHM",
                    kategori: "HGA",
                    qrcode: "HDH/XXXXX",
                    locator: "WDD1D1D1",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodehadiah: "XXXX",
                    namahadiah: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodehadiah: "XXXX",
                    namahadiah: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodehadiah: "XXXX",
                    namahadiah: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodehadiah: "XXXX",
                    namahadiah: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
                {
                    id: 2,
                    kodehadiah: "XXXX",
                    namahadiah: "XXXX",
                    kategori: "XXX",
                    qrcode: "XXXX",
                    locator: "XXXXX",
                    jmlprint: "",
                },
            ],
            secondPanelData: [
                {
                    id: 1,
                    kodehadiah: "H1234",
                    namahadiah: "Jaket NIM",
                    kategori: "Jaket Gift",
                    jumlah: 5,
                    satuan: "Pcs",
                    locator: "WH010101",
                },
                {
                    id: 2,
                    kodehadiah: "H321",
                    namahadiah: "Sarung Tangan",
                    kategori: "Glove",
                    jumlah: 10,
                    satuan: "Set",
                    locator: "WHD1D1D1",
                },
            ],
        },
    },
    ksu: {
        ...inputConfig.ksu,
        table: {
            type: "single",
            firstPanelConfig: [
                {
                    name: "kodeKSU",
                    label: "Kode KSU",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value.value : "-";
                        },
                    }
                },
                {
                    name: "namaKSU",
                    label: "Nama KSU",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value : "-";
                        }
                    }
                },
                {
                    name: "kategori",
                    label: "Kategori",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value : "-";
                        }
                    }
                },
                {
                    name: "jumlah",
                    label: "Jumlah",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value : "-";
                        }
                    }
                },
                {
                    name: "kodeLocation",
                    label: "Locator",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value.label : "-";
                        },
                    }
                },
                {
                    name: "qrCode",
                    label: "QRCode",
                    options: {
                        customBodyRender: (value) => {
                            return value ? value : "-";
                        }
                    }
                },
                {
                    name: "numbersOfPrint",
                    label: "Jml. Print QR",
                    options: {
                        customBodyRender: (value) => {
                            return value;
                        }
                    }
                },
            ],
            secondPanelConfig: (
                dataKSU,
                dataLocator,
                dataTable,
                handleSelectCodeKSU,
                handleValueChange,
                handleMultipleLocatorChange,
                handleSingleLocatorChange,
                handleSaveRow,
                handleEditRow,
                handleDeleteRow,
            ) => {
                return [
                  {
                    name: "id",
                    label: "No",
                    options: {
                      customBodyRender: (_, tableMeta) => {
                        const { page, rowsPerPage } = tableMeta.tableState;
                        const rowNumber =
                          page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                      },
                    },
                  },
                  {
                    name: "kodeKSU",
                    label: "Kode KSU",
                    options: {
                      customBodyRender: (value, { rowIndex, rowData }) => {
                        const isSaved = rowData[rowData.length - 1];
                        const tempLabel = value?.label?.split('-') || []
                        return isSaved ? (
                          <p>{tempLabel[0]}</p>
                        ) : (
                          <SimpleDDL
                            id={`select_options_kode_hadiah_${rowIndex}`}
                            containerclassname="margin-bottom-none width width-250px"
                            box={"search"}
                            menuPosition="fixed"
                            options={dataKSU.map((item) =>
                              mapToObjectDDL(`${item.kodeKSU} - ${item.name}`, item.kodeKSU)
                            )}
                            readOnly={isSaved}
                            isClearable={true}
                            value={value}
                            onChange={(value) =>
                              handleSelectCodeKSU(rowIndex, "kodeKSU", value)
                            }
                          />
                        );
                      },
                      sort: false,
                    },
                  },
                  {
                    name: "namaKSU",
                    label: "Nama KSU",
                    options: {
                      customBodyRender: (val) => <p>{val}</p>,
                      sort: false,
                    },
                  },
                  {
                    name: "kategori",
                    label: "Kategori",
                    options: {
                      customBodyRender: (val) => <p>{val}</p>,
                      sort: false,
                    },
                  },
                  {
                    name: "jumlah",
                    label: "Jumlah",
                    options: {
                      customBodyRender: (
                        val,
                        { rowIndex, rowData, columnData }
                      ) => {
                        const isSaved = rowData[rowData.length - 1];
                        return isSaved ? (
                          <p>{val}</p>
                        ) : (
                          <SimpleInput
                            value={val}
                            containerclassname="margin-bottom-none width width-100px"
                            readOnly={isSaved}
                            box="onlyNumber"
                            onChange={(e) =>
                              handleValueChange(
                                rowIndex,
                                columnData.name,
                                e.target.value
                              )
                            }
                          />
                        );
                      },
                      sort: false,
                    },
                  },
                  {
                    name: "kodeLocation",
                    label: "[*] All Locator",
                    options: {
                      customHeadRender: (props) => {
                        return (
                          <th className="custom-locator">
                            <FlexView
                              vAlignContent="center"
                              style={{ gap: "10px" }}
                            >
                              <p>{props.label}</p>
                              <SimpleDDL
                                id="select_options_header_locator"
                                containerclassname="margin-bottom-none width width-250px"
                                box="search"
                                isClearable={true}
                                styles={{
                                  menu: (provided) => ({
                                    ...provided,
                                    position: "relative",
                                    fontFamily:
                                      "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                  }),
                                }}
                                options={
                                  dataLocator
                                    ? dataLocator.map((item) =>
                                        mapToObjectDDL(
                                          item.nameLocation,
                                          item.kodeLocation
                                        )
                                      )
                                    : []
                                }
                                onChange={handleMultipleLocatorChange}
                              />
                            </FlexView>
                          </th>
                        );
                      },
                      customBodyRender: (val, { rowIndex, rowData }) => {
                        const isSaved = rowData[rowData.length - 1];
                        return isSaved ? (
                          <p>{val?.label}</p>
                        ) : (
                          <SimpleDDL
                            id={`select_options_locator_${rowIndex}`}
                            containerclassname="margin-bottom-none width width-250px"
                            box="search"
                            value={val}
                            menuPosition="fixed"
                            options={
                              dataLocator
                                ? dataLocator.map((item) =>
                                    mapToObjectDDL(
                                      item.nameLocation,
                                      item.kodeLocation
                                    )
                                  )
                                : []
                            }
                            readOnly={isSaved}
                            isClearable={true}
                            onChange={(value) =>
                              handleSingleLocatorChange(rowIndex, value)
                            }
                          />
                        );
                      },
                      sort: false,
                    },
                  },
                  {
                    name: "saved",
                    label: "Aksi",
                    options: {
                      customBodyRender: (val, { rowIndex, rowData }) => (
                        <FlexView style={{ gap: "10px" }}>
                          {!val ? (
                            <SimpleButton
                              className={"btn background-red"}
                              styles={{ width: "unset", marginLeft: "0px" }}
                              onClick={() => handleSaveRow(rowIndex)}
                              icon={<i className="fa fa-save" />}
                            />
                          ) : dataTable[rowIndex]?.checkEdit !== false ? (
                            <>
                              <SimpleButton
                                className={"btn background-red"}
                                styles={{ width: "unset", marginLeft: "0px" }}
                                onClick={() => handleEditRow(rowIndex)}
                                icon={<i className="fa fa-lw fa-pencil-alt" />}
                              />
                              <SimpleButton
                                className={"btn background-red"}
                                styles={{ width: "unset", marginLeft: "0px" }}
                                onClick={() => handleDeleteRow(rowIndex)}
                                icon={<i className="fa fa-trash"></i>}
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </FlexView>
                      ),
                      sort: false,
                    },
                  },
                ];
            },
        },
    },
};

export const modalContentConfig = {
    hadiah: {
        codeName: "kodehadiah",
        codeLabel: "Kode Hadiah",
        itemName: "namahadiah",
        itemLabel: "Nama Hadiah",
        buttonLabel: "HADIAH",
        buttonName: "Hadiah",
    },
    baranglain: {
        codeName: "kodebarang",
        codeLabel: "Kode Barang",
        itemName: "namabaranglain",
        itemLabel: "Nama Barang Lain",
        buttonLabel: "Barang Lain",
        buttonName: "Barang",
    },
    ksu: {
        codeName: "kodeKSU",
        codeLabel: "Kode KSU*",
        itemName: "namaKSU",
        itemLabel: "Nama KSU",
        buttonLabel: "UNIT KSU",
        buttonName: "KSU",
    },
};
